import React from "react";

const Main = () => {
  return (
    <section class="w-full h-[38vh] bg-[#662a23] flex items-center justify-center space-x-20 pt-9 ">
      <p class="w-[50vh] text-lg text-white">
        Consulting comprises a team of high-calibre strategic consultants,
        energy economists, engineers, technicians and project delivery
        professionals.
      </p>
      <p class="w-[70vh] text-white text-base">
        We specialise in power distribution, transmission and generation
        projects. The Merz team are able to deliver projects from idea
        inception, through power system planning and feasibility studies,
        detailed design, commissioning and ongoing support. We also provide a
        comprehensive range of energy-related services and independent
        specialised opinions.
      </p>
    </section>
  );
};

export default Main;
